import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Home() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [justDuplicated, setJustDuplicated] = useState(null);

  useEffect(() => {
    axios.get('/api/projects')
      .then(res => setProjects(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Delete this project?')) {
      await axios.delete(`/api/projects/${id}`);
      setProjects(projects.filter(p => p.id !== id));
    }
  };

  const handleEdit = (project) => {
    if (project.results?._form) {
      navigate('/form', {
        state: {
          form: project.results._form,
          projectName: project.project_name,
          fileName: project.file_name,
          isEditing: true,
          projectId: project.id
        }
      });
    } else {
      // Legacy project saved before _form was introduced — open as read-only
      navigate('/results', {
        state: {
          results: project.results,
          projectName: project.project_name,
          fileName: project.file_name,
          form: { structureType: project.structure_type }
        }
      });
    }
  };

  const handleDuplicate = async (project) => {
    try {
      await axios.post('/api/projects', {
        projectName: `Copy of ${project.project_name}`,
        structureType: project.structure_type,
        fileName: project.file_name,
        results: project.results
      });
      const res = await axios.get('/api/projects');
      setProjects(res.data);
      setJustDuplicated(project.id);
      setTimeout(() => setJustDuplicated(null), 2000);
    } catch (err) {
      alert('Error duplicating project.');
    }
  };

  const filteredProjects = projects
    .filter(p => filterType === 'all' || p.structure_type === filterType)
    .filter(p => !search || p.project_name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <div className="page-header">
        <div className="breadcrumb">Home / <strong>Project History</strong></div>
        <h1 className="page-title">Projects</h1>
        <p className="page-subtitle">Your saved material calculations</p>
      </div>

      {projects.length > 0 && (
        <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'center' }}>
          <div style={{ position: 'relative', flex: 1 }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#999', fontSize: '14px', pointerEvents: 'none' }}>🔍</span>
            <input
              style={{ width: '100%', padding: '8px 12px 8px 32px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }}
              placeholder="Search by project name..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <select
            style={{ padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '14px', background: 'white', cursor: 'pointer' }}
            value={filterType}
            onChange={e => setFilterType(e.target.value)}
          >
            <option value="all">All Types</option>
            <option value="screen_enclosure">Screen Enclosure</option>
            <option value="screen_porch">Screen Porch</option>
            <option value="mixed">Mixed</option>
            <option value="mansard">Mansard</option>
          </select>
        </div>
      )}

      {projects.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', color: '#666', padding: '48px' }}>
          No projects yet. Click <strong>+ New Project</strong> to get started.
        </div>
      ) : filteredProjects.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', color: '#999', padding: '48px' }}>
          No projects match your search.
        </div>
      ) : (
        filteredProjects.map(project => (
          <div key={project.id} className="card project-card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ fontSize: '32px' }}>🏠</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '15px' }}>{project.project_name}</div>
                <div style={{ fontSize: '13px', color: '#666' }}>Structure Type: {project.structure_type}</div>
                <div style={{ fontSize: '13px', color: '#666' }}>Date Created: {new Date(project.created_at).toLocaleDateString()}</div>
              </div>
            </div>
            <div className="project-card-actions" style={{ display: 'flex', gap: '8px' }}>
              <button className="btn-primary" onClick={() => navigate('/results', { state: { results: project.results, projectName: project.project_name, fileName: project.file_name, form: project.results?._form || { structureType: project.structure_type }, isViewing: true, projectId: project.id } })}>
                Open →
              </button>
              <button
                className="btn-secondary"
                onClick={() => handleDuplicate(project)}
                style={{ fontSize: '13px', color: justDuplicated === project.id ? '#34a853' : undefined }}
              >
                {justDuplicated === project.id ? '✓ Duplicated' : 'Duplicate'}
              </button>
              <button className="btn-secondary" onClick={() => handleEdit(project)}>
                Edit ✏️
              </button>
              <button className="btn-danger" onClick={() => handleDelete(project.id)}>
                🗑 Delete
              </button>
            </div>
          </div>
        ))
      )}

      {filteredProjects.length > 0 && (
        <div style={{ textAlign: 'center', color: '#999', fontSize: '13px', marginTop: '24px' }}>
          {filteredProjects.length} project{filteredProjects.length !== 1 ? 's' : ''} shown.
        </div>
      )}
    </div>
  );
}

export default Home;